import { apiPost } from '../api'

export const issue_fine = data => {
  return apiPost({
    endpoint: 'attendance/issue_fine',
    data: data
  })
}
